var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5605 8.92749V5.57098C17.5605 2.49902 15.0613 0 11.9896 0C8.9176 0 6.41858 2.49902 6.41858 5.57098V8.92749H4.21875V24H19.7604V8.92749H17.5605ZM7.82483 5.57098C7.82483 3.27448 9.69305 1.40625 11.9896 1.40625C14.2861 1.40625 16.1543 3.27448 16.1543 5.57098V8.92749H7.82483V5.57098ZM18.3541 22.5938H5.625V10.3337H18.3541V22.5938Z",
    fill: "#828FAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2864 17.8841V20.4212H12.6927V17.8841C13.8994 17.5714 14.7933 16.4731 14.7933 15.1697C14.7933 13.624 13.5355 12.3662 11.9896 12.3662C10.4436 12.3662 9.18585 13.6238 9.18585 15.1697C9.18585 16.4731 10.0796 17.5714 11.2864 17.8841ZM11.9896 13.7725C12.7601 13.7725 13.387 14.3992 13.387 15.1699C13.387 15.9404 12.7601 16.5672 11.9896 16.5672C11.2191 16.5672 10.5921 15.9404 10.5921 15.1697C10.5921 14.3992 11.2191 13.7725 11.9896 13.7725Z",
    fill: "#828FAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.0072cd4c.svg";
export { ForwardRef as ReactComponent };